import { CustomRoute } from "@router/types";
import authCodeMap from "@/dataBase/authCodeMap";
const routes: Array<CustomRoute> = [
  // {
  //   path: "/marketing",
  //   name: authCodeMap.marketing,
  //   component: (): any => import("@/modules/router.vue"),
  //   redirect: "/marketing/inviteActicityManage",
  //   meta: {
  //     title: "营销",
  //     hidden: false,
  //     icon: "tree",
  //     needLogin: true,
  //     authCode: authCodeMap.marketing,
  //   },
  //   children: [
  //     {
  //       path: "inviteActicityManage",
  //       name: authCodeMap.invite_acticity_manage,
  //       component: (): any => import("@/modules/marketing/pages/inviteActicityManage/index.vue"),
  //       redirect: "/marketing/inviteActicityManage/activityRegistration",
  //       meta: {
  //         title: "营销_邀约管理",
  //         hidden: false,
  //         needLogin: true,
  //         authCode: authCodeMap.invite_acticity_manage,
  //       },
  //       children: [
  //         {
  //           path: "activityRegistration",
  //           name: authCodeMap.activity_registration,
  //           component: (): any => import("@/modules/marketing/pages/inviteActicityManage/activityRegistration/index.vue"),
  //           meta: {
  //             title: "营销_邀约管理_活动报名",
  //             hidden: false,
  //             needLogin: true,
  //             authCode: authCodeMap.activity_registration,
  //           },
  //         },
  //         {
  //           path: "activityRegistration_edit",
  //           name: authCodeMap.activity_registration_edit,
  //           component: (): any => import("@/modules/marketing/pages/inviteActicityManage/activityRegistration/edit.vue"),
  //           meta: {
  //             title: "营销_邀约管理_活动报名_编辑",
  //             hidden: false,
  //             needLogin: true,
  //             authCode: authCodeMap.activity_registration_edit,
  //           },
  //         },
  //         {
  //           path: "productManage_add",
  //           name: authCodeMap.marketing_operationManage_productManage_add,
  //           component: (): any => import("@/modules/marketing/pages/inviteActicityManage/productManage/edit.vue"),
  //           meta: {
  //             title: "营销_产品管理_商品添加",
  //             hidden: false,
  //             needLogin: true,
  //             authCode: authCodeMap.marketing_operationManage_productManage_add,
  //           },
  //         },
  //         {
  //           path: "productManage",
  //           name: authCodeMap.marketing_operationManage_productManage,
  //           component: (): any => import("@/modules/marketing/pages/inviteActicityManage/productManage/index.vue"),
  //           meta: {
  //             title: "营销_产品管理_商品",
  //             hidden: false,
  //             needLogin: true,
  //             authCode: authCodeMap.marketing_operationManage_productManage,
  //           },
  //         },
  //         {
  //           path: "productDetail",
  //           name: authCodeMap.marketing_operationManage_productManage_detail,
  //           component: (): any => import("@/modules/marketing/pages/inviteActicityManage/productManage/detail.vue"),
  //           meta: {
  //             title: "营销_产品管理_商品",
  //             hidden: false,
  //             needLogin: true,
  //             authCode: authCodeMap.marketing_operationManage_productManage_detail,
  //           },
  //         },
  //         {
  //           path: "infoManage",
  //           name: authCodeMap.marketing_operationManage_infoManage,
  //           component: (): any => import("@/modules/marketing/pages/inviteActicityManage/infoManage/InfoManagePage.vue"),
  //           meta: {
  //             title: "营销_平台活动管理_零售商信息管理",
  //             hidden: false,
  //             needLogin: true,
  //             authCode: authCodeMap.marketing_operationManage_infoManage,
  //           },
  //         },
  //       ],
  //     },
  //   ],
  // },
];
export default routes;
